import React, { useState } from "react";
import Logo from "../assets/amal-logo-2.png";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { QrReader } from "react-qr-reader";
import AttributeSearchbar from "../components/AttributesSearch";

export default function SearchPage() {
  let urlParams = new URLSearchParams(window.location.search);
  const navigate = useNavigate();
  const [showQr, setShowQr] = useState(false);
  const [attributes, setAttributes] = useState([]);
  const [filterType, setFilterType] = useState("all");


  const handelSubmit = () => {
    // urlParams.append("search", search)
    const filters = {
      filterType,
    };
    let locationChip = false;

    const filteredAttributes = attributes.filter((item) => item.type !== "Location");
    filters["attributes"] = filteredAttributes;

    attributes.forEach((item) => {
      if (item.type === "Location") {
        filters["equalto___location_id"] = item.id;
        locationChip = {
          type: "equalto___location_id",
          label: item.label,
          id: item.id,
        };
        return false;
      }
    });
    navigate("/Swatches?" + urlParams.toString(), {
      state: { filters, locationChip },
    });
  };

  const handleScan = (result) => {
    if (result && result !== "") {
      const uniqueCode = result.text;
      urlParams.append("search", uniqueCode);
      navigate("/Swatches?" + urlParams.toString());
      setShowQr(false);
    }
  };
  if (!showQr) {
    return (
      <div className="search-page-wrapper">
        <div className="amal-logo">
          <img alt="Amal Logo" src={Logo} />
        </div>
        <div className="search-bar">
          <AttributeSearchbar
            onSubmit={handelSubmit}
            onScanClick={() => setShowQr(true)}
            filterType={filterType}
            setFilterType={setFilterType}
            search={attributes}
            setSearch={setAttributes}
            showLocation
          />
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <QrReader
          className="scanner"
          constraints={{ facingMode: "environment" }}
          onResult={handleScan}
          style={{ width: "100%" }}
        />
        <button className="close-btn" onClick={() => setShowQr(false)}>
          <CloseIcon />
        </button>
      </div>
    );
  }
}
